import { useTranslation } from "react-i18next";
import type { CalendarLabels } from "./Calendar";
import type { LanguageCode } from "../api/contracts/language-settings";
import { getLanguageCode } from "../utils/language";
import { useAdFormat } from "../hooks/useAdFormat";

export interface CalendarLocalization {
  labels: CalendarLabels;
  languageCode: LanguageCode;
}

export const useCalendarLabels = (): CalendarLocalization => {
  const { t } = useTranslation();
  // An activity booking has no arrival or departure — the picked dates bound
  // the days being searched, so the pills read as a plain date range.
  const { isActivity: isActivitySite } = useAdFormat();
  return {
    labels: {
      weekdays: [
        t("calendar.weekdays.mon"),
        t("calendar.weekdays.tue"),
        t("calendar.weekdays.wed"),
        t("calendar.weekdays.thu"),
        t("calendar.weekdays.fri"),
        t("calendar.weekdays.sat"),
        t("calendar.weekdays.sun"),
      ],
      arrival: isActivitySite ? t("header.date_from") : t("header.arrival"),
      departure: isActivitySite ? t("header.date_to") : t("header.departure"),
      stopTimeStayDateNotice: t("calendar.stop_time_stay_date_notice"),
      loadingAvailability: t("calendar.loading_availability"),
    },
    languageCode: getLanguageCode(),
  };
};
